// Age & validation utilities
export function ageParts(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  if (isNaN(d.getTime())) return null;
  const now = new Date();
  let years = now.getFullYear() - d.getFullYear();
  let months = now.getMonth() - d.getMonth();
  if (now.getDate() < d.getDate()) months -= 1;
  if (months < 0) {
    years -= 1;
    months += 12;
  }
  if (years < 0) return { years: 0, months: 0 };
  return { years, months };
}

export function formatAge(iso, opts = {}) {
  const parts = ageParts(iso);
  if (!parts) return "—";
  const { years, months } = parts;
  const { lang = "ro", approximate = false } = opts;
  const yLabel = lang === "ro" ? "ani" : "years";
  const mLabel = lang === "ro" ? "luni" : "months";
  const yOne = lang === "ro" ? "an" : "year";
  const mOne = lang === "ro" ? "lună" : "month";
  const parts_str = [];
  if (years > 0) parts_str.push(`${years} ${years === 1 ? yOne : yLabel}`);
  if (months > 0 || years === 0) parts_str.push(`${months} ${months === 1 ? mOne : mLabel}`);
  const label = parts_str.join(", ") || "0";
  const approxWord = lang === "ro" ? "aproximativ" : "approximately";
  return approximate ? `${approxWord} ${label}` : label;
}

export function sanitizePhone(v) {
  if (!v) return "";
  return v.replace(/[^\d+\s()-]/g, "");
}

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export function isValidEmail(v) {
  if (!v) return true; // empty is allowed (validation on submit only if required)
  return EMAIL_RE.test(v);
}


// Parse a user-typed decimal string into a Number. Accepts either dot ("12.3")
// or comma ("12,3") as the decimal separator — the Romanian mobile keyboard
// only exposes the comma, so `type="number"` inputs silently reject valid
// decimals. Use with `<input type="text" inputMode="decimal">` for good UX.
export function parseDecimal(v) {
  if (v == null || v === "") return 0;
  const s = String(v).replace(/,/g, ".").replace(/[^\d.\-]/g, "");
  const n = Number(s);
  return Number.isFinite(n) ? n : 0;
}

// Translate the raw species/sex/status values that live in the DB into the
// user's active language. Falls back to the raw value for custom species
// (rabbit, parrot, etc.) that don't have a translation key.
export function speciesLabel(species, t) {
  const s = (species || "").toLowerCase().trim();
  if (!s) return "—";
  if (s === "dog") return t("dog");
  if (s === "cat") return t("cat");
  if (s === "other") return t("other");
  return species; // custom, keep as typed
}

export function sexLabel(sex, t) {
  const s = (sex || "").toLowerCase().trim();
  if (!s) return "—";
  if (s === "male" || s === "m") return t("male");
  if (s === "female" || s === "f") return t("female");
  return sex;
}
